var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOffice = function SvgOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 56",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.309 7H1.69L0 0h44zM3 11v45h15.545V45.616h6.907V56h15.545L41 11H3zm12.092 31.153H8.185v-6.922h6.907v6.922zm0-10.384H8.185v-6.922h6.907v6.922zm0-10.385H8.185v-6.921h6.907v6.921zm10.363 20.77h-6.907V35.23h6.907v6.922zm0-10.385h-6.907v-6.922h6.907v6.922zm0-10.385h-6.907v-6.921h6.907v6.921zm10.364 20.77H28.91V35.23h6.908v6.922zm0-10.385H28.91v-6.922h6.908v6.922zm0-10.385H28.91v-6.921h6.908v6.921z",
    fillRule: "evenodd"
  })));
};

export default SvgOffice;